import { useMemo } from 'react';

import { ErrorOutlined } from '@mui/icons-material';
import { ActionItemKeys } from '@uplift/api';
import { paymentsTabRoute } from '@uplift/constants';
import { trackToDoCTA, useActionItem, useL10n } from '@uplift/hooks';
import { UserRole } from '@uplift/types';
import { LinkDashboardActionItem } from '@uplift/ui-v2';

export const useOutstandingBalanceActionItem = () => {
  const l10n = useL10n();
  const outstandingBalanceItem = useActionItem(ActionItemKeys.CLIENT_OUTSTANDING_BALANCE);

  const balanceActionItem = useMemo(() => {
    if (!outstandingBalanceItem.show) {
      return null;
    }

    return (
      <LinkDashboardActionItem
        title={l10n.dashboard.actionItems.outstandingBalance.title(outstandingBalanceItem.balance)}
        details={l10n.dashboard.actionItems.outstandingBalance.text}
        color="danger"
        icon={<ErrorOutlined />}
        link={paymentsTabRoute.createLink({ tab: 'overview' })}
        actionText={l10n.dashboard.actionItems.outstandingBalance.actionText}
        onClick={() =>
          trackToDoCTA({
            toDoType: ActionItemKeys.CLIENT_OUTSTANDING_BALANCE,
            userType: UserRole.patient
          })
        }
      />
    );
  }, [ l10n.dashboard.actionItems.outstandingBalance, outstandingBalanceItem.balance, outstandingBalanceItem.show ]);

  return {
    actionItem: balanceActionItem,
    isLoading: outstandingBalanceItem.isLoading
  };
};
